import BaseScreenProvider from "./BaseScreenProvider";

export class CommonScreenProvider extends BaseScreenProvider {
    detectScreen() {
        if (matchMedia("only screen and (min-width: 1280px)").matches) {
            return 1280;
        }
        if (matchMedia("only screen and (min-width: 960px)").matches) {
            return 960;
        }
        if (matchMedia("only screen and (min-width: 720px)").matches) {
            return 720;
        }
        if (matchMedia("only screen and (min-width: 480px)").matches) {
            return 480;
        }

        return 320;
    }
}

export default new CommonScreenProvider(); 